/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    code: "code",
    pre: "pre"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "How can I override inline styles?"
    }), "\n", _jsx(_components.p, {
      children: "Inline styles will always take precedence over external CSS, so you cannot override it by simply increasing specificity."
    }), "\n", _jsxs(_components.p, {
      children: ["There is a neat trick however, which is to use the style ", _jsx(_components.code, {
        children: "element-attr"
      }), " CSS Selector in conjunction with ", _jsx(_components.code, {
        children: "!important"
      }), ":"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "const MyStyledComponent = styled(InlineStyledComponent)`\n  &[style] {\n    font-size: 12px !important;\n    color: blue !important;\n  }\n`\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
